//  @ts-nocheck
import React, {
  useState,
  Dispatch,
  useEffect,
  createRef,
  SetStateAction,
} from 'react';
import { action } from 'mobx';
import ReactSVG from 'react-svg';
import { IImageMayBe } from 'global';
import { debounce } from 'utils/util';
import intl from 'react-intl-universal';
import { createPortal } from 'react-dom';
import { inject, observer } from 'mobx-react';
import { ILoadPicParams } from 'store/GalleryStore';
import { printImageWithOrientation } from 'utils/print-image';

import BigPic from './BigPic';
import stat from '../../utils/stat';
import usePicPay from './usePicPay';
import RootStore from '../../store/RootStore';
import usePortalDom from '../hooks/usePortalDom';

export interface IShowBigPic {
  index?: number;
  id?: number;
}

export const BIGPIC_PRELOAD_LENGTH = 4;

export interface ICurrentImageMaybe {
  id: number;
  maybe: IImageMayBe;
}
interface IFriendInfo {
  personid: number;
  status?: string;
}

interface IAllForBigPic {
  rootStore?: RootStore;
  loadPic: (params: ILoadPicParams) => void;
  list: any[];
  setList: (list: any[]) => void;
  currentPropIndex: number;
  setCurrentPropIndex: Dispatch<SetStateAction<number>>;
  total: number;
  currentPayGood?: any;
  currentPayedImages?: any;
}


const AllForBigPic = function (props: IAllForBigPic) {
  const {
    list,
    setList,
    total,
    currentPropIndex,
    setCurrentPropIndex,
    currentPayGood,
  } = props;
  const [isLike, setIsLike] = useState(false); // 当前照片是否是用户喜欢
  const bigpicEle = createRef<HTMLDivElement>();

  const [friendInfo] = useState<IFriendInfo>({ personid: 0 });

  const hideBigPic = () => {
    setCurrentPropIndex(-1);
  };

  //  使用键盘左右键切换图片,Esc退出
  // useKeydownToChangeIndex(currentPropIndex, setCurrentPropIndex, list);

  // 在某些情况下只是需要插入maybe而不需要重设index
  const showBigPic = (params: IShowBigPic, shouldSetIndex = true) => {
    //由于流程是用的flowList，已经和原有list脱节了，所以不得不使用id然后获取当前id的index
    let { id, index = -1 } = params;
    if (id) {
      index = list.findIndex((one) => {
        return one.id === id;
      });
    }
    if (index === -1) {
      return;
    }

    const image = list[index];
    stat.page('gallery');
    stat.event('image', image.id);

    // 在PC大图页上，点击左右需要调用这个方法去修改一次
    if (shouldSetIndex) {
      setCurrentPropIndex(index);
    } else {
      insertMaybe(image, index);
    }
  };
  // currentPropIndex 变更时，达到了最大长度后加载更多的图片
  const bigPicScrollLower = () => {
    props.loadPic({
      uselasttime: true,
    });
  };
  useEffect(() => {
    if (
      list.length - currentPropIndex <= 4 &&
      // list.length - 1 === currentPropIndex &&
      list.length !== total &&
      total > 0
    ) {
      console.log(`加载下一页`);
      bigPicScrollLower();
    }
  }, [list.length - currentPropIndex <= 4, total]);

  // 当前currentPropIndex变更时需要考虑是否需要插入maybe的数据
  // 注意，务必将list加入到依赖中，如果不加入的话，list可能获取的是之前的数据，在某些情况下
  // 会因为setList导致最终的数组长度问题！！！！
  useEffect(() => {
    showBigPic({ index: currentPropIndex }, false);
  }, [currentPropIndex]);

  // index变更时需要获取当前用户是否喜欢当前照片的数据
  useEffect(() => {
    if (currentPropIndex !== -1) {
      const theOne = list[currentPropIndex];
      const { id } = theOne;
      props
        .rootStore!.wxuserStore.like(window.gallery.id + '', id)
        .then((dt: any) => {
          const { data } = dt;
          setIsLike(data[id]);
        });
    }
  }, [currentPropIndex]);

  const getFaceMaybe = (imageid: number) => {
    if (!imageid) {
      console.warn(imageid, 'imageid is null');
      return new Promise<void>((resolve) => resolve());
    }
    return props.rootStore!.wxuserStore.faceMaybe(imageid);
  };

  const insertMaybe = (image: ICurrentImageMaybe, index: number) => {
    const { use_face } = window.configDetail;

    //只有没有获取过才获取，减少服务器压力
    if (Number(use_face) && !image.maybe) {
      getFaceMaybe(image.id).then((data: any) => {
        //需要排个序，把当前人物放在第一个
        const currentPersonId = friendInfo.personid;
        const thePersonIndex = data.findIndex(
          (onePerson: IFriendInfo) => onePerson.personid == currentPersonId
        );
        if (thePersonIndex !== -1) {
          const thePerson = data.splice(thePersonIndex, 1);
          data = thePerson.concat(data);
        } else {
          // console.log('图上没有自己');
        }

        image.maybe = data;
        // console.log(list.length, ' all for big pic get face maybe');
        setList([...list.slice(0, index), image, ...list.slice(index + 1)]);
      });
    }
  };

  const setIndex = (list: any[], index: number, params: any) => {
    setList([
      ...list.slice(0, index),
      {
        ...list[index],
        ...params,
      },
      ...list.slice(index + 1),
    ]);
  };

  const loadError = (index: number) => {
    // console.log(`load Error`, index);
    if (-1 === index) {
      return;
    }
    var current = list[index];
    if (!current) {
      return;
    }
    //只有点击加载大图(loadBigPic)才需要修改状态
    if (current.loadStatus === 'loading') {
      // list[currentPropIndex].loadStatus = 'loaded';
      setIndex(list, index, { loadStatus: null });
      props.rootStore!.uiStore.hideToast();
      props.rootStore!.uiStore.showToast({
        time: 1000,
        content: intl.get('LoadError'),
      });
    }
  };

  const loadFinish = (index: number, size?: number) => {
    console.log(index, size);
    if (-1 === index) {
      return;
    }
    var current = list[index];
    if (!current) {
      return;
    }
    if (size) {
      setIndex(list, index, { size });
    }
    //只有点击加载大图(loadBigPic)才需要修改状态
    if (current.loadStatus === 'loading') {
      setIndex(list, index, { loadStatus: 'loaded' });
    }
  };

  const longPress = () => {
    const image = list[currentPropIndex];
    stat.event('image_download', image.id);
  };

  const loadBigPic = (index?: number) => {
    // noinspection SuspiciousTypeOfGuard
    let dataIndex =
      typeof index != 'undefined' && typeof index === 'number'
        ? index
        : currentPropIndex;
    //loaded字段标识当前是否已经下载过大图:"loading","loaded",undefined
    //正在加载中的 ，点击无效
    if (list[dataIndex] && list[dataIndex].loadStatus === 'loading') {
      return;
    }

    // 已经加载过，点击无效
    if (list[dataIndex] && list[dataIndex].loadStatus === 'loaded') {
      return;
    }

    // 不知道为什么没有触发新的修改
    // list[dataIndex].loadStatus = "loading";
    setIndex(list, dataIndex, { loadStatus: 'loading' });
    const image = list[dataIndex];
    stat.event('image_full', image.id);
  };

  const [printIndex, setPrintIndex] = useState<number>(-1);

  useEffect(() => {
    /**
     * 这儿是打印的逻辑
     * 检测到printIndex变化后，获取当前的状态
     * 如果是loading状态，提示用户正在加载
     * 如果是undefined状态，调用loadBigPic
     * 如果是loaded状态，获取当前的图片，然后打印
     *
     * 打印完毕后，将printIndex设置为-1
     */
    if (printIndex === -1) {
      return;
    }
    const status = list[printIndex]?.loadStatus;

    if (status === undefined) {
      loadBigPic(printIndex);
      return;
    }
    if (status === 'loading') {
      props.rootStore!.uiStore.showToast({
        content: intl.get('Loading'),
        time: 5000,
      });
      return;
    }

    const containerList = document.querySelectorAll(
      '.all-for-big-pic .react-swipeable-view-container>div'
    );
    const container = containerList[printIndex] as HTMLElement;
    if (!container) {
      setPrintIndex(-1);
      console.log('no print container');
      return;
    }
    const image = container.querySelector('img') as HTMLImageElement;
    if (!image) {
      setPrintIndex(-1);
      console.log('no print img');
      return;
    }
    printImageWithOrientation(image);
    setPrintIndex(-1);
  }, [printIndex, loadBigPic, list]);

  const printCurrentImage = (index: any) => {
    setPrintIndex(index as unknown as number);
  };

  // const [showBottomComment, setShowBottomComment] = useState(false);
  // const [bottomCommentTab, setBottomCommentTab] = useState(0);
  const setBottomComment = () => {
    // setShowBottomComment(prevState => !prevState);
    // setBottomCommentTab(tab);
    const event = new Event('show-bottom-comment') as any;
    event.customType = 'for-big-pic';
    window.dispatchEvent(event);
  };

  const loveit = debounce(() => {
    const { id } = list[currentPropIndex];
    const galleryid = window.gallery.id;
    const path = list[currentPropIndex].hash || '';
    const { rootStore, setList } = props;
    const { wxuserStore, uiStore } = rootStore!;
    wxuserStore.sendLove({ id, galleryid, path }).then(
      action((jsonData: any) => {
        const { count } = jsonData;
        list[currentPropIndex] = {
          ...list[currentPropIndex],
          love: count,
        };
        setList(list.slice(0));

        stat.event('image_love', id);
        setIsLike((prevState) => {
          uiStore.showToast({
            // time:999999,
            // 不知道为什么会报警，先不管了
            content: prevState ? (
              intl.get('Removed from my fav photo')
            ) : (
              <div key={id}>
                <ReactSVG
                  src={require('../../svg/heart-red.svg')}
                  style={{ width: 45, height: 43, margin: '0 auto' }}
                />
                <span>{intl.get('Added to my fav photo')}</span>
              </div>
            ),
          });
          return !prevState;
        });
      })
    );
  });

  // noinspection JSUnusedLocalSymbols
  const onZoomStart = (index: number) => {
    loadBigPic(index);
    // }
  };

  // 大图页用Portal跳出去，否则在有bottom-tab等情况无法正常全屏显示

  // 注意，特地吧currentPropIndex !==-1的判断放在这个文件而不是上一层
  // 考虑到这一层的诸如获取好友信息等，不需要在显示和隐藏的时候做额外获取
  // 还有诸如锁定滚动之类的方便根据currentPropIndex处理

  const wrapper = usePortalDom({
    targetClassName: 'big-pic',
    parentElement: window.document.getElementById('root-page')! as HTMLElement,
  });

  const { currentIndexIsPayed, currentPayWatermark, currentPayId } = usePicPay({
    currentPayGood,
    list,
    index: currentPropIndex,
    rootStore: props.rootStore,
  });

  //  第一层: 这儿这样做的目的是为了在currentPropIndex变化时，不会立即关闭大图, 给页面一定的动画时间
  const [current, setCurrent] = useState(currentPropIndex);
  useEffect(() => {
    if (currentPropIndex === -1) {
      setTimeout(() => {
        setCurrent(-1);
        //  这儿的10ms是为了让动画有时间展示, 请不要随意修改
      }, 10);
    } else {
      const timer = setTimeout(() => {
        setCurrent(currentPropIndex);
        //  这儿的300ms是为了让动画有时间展示, 请不要随意修改, 和CloseAnimation的时间有关联
      }, 300);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [currentPropIndex]);

  return wrapper
    ? createPortal(
        <div className="all-for-big-pic" ref={bigpicEle}>
          {current !== -1 && (
            <BigPic
              showBigPic={showBigPic}
              setCurrentImageIndex={setCurrentPropIndex}
              loadBigPic={loadBigPic}
              loadPic={props.loadPic}
              loadFinish={loadFinish}
              loadError={loadError}
              hideBigPic={hideBigPic}
              onLongPress={longPress}
              onZoomStart={onZoomStart}
              currentImageIndex={current}
              list={list}
              total={total}
              showComment={setBottomComment}
              commentTotal={props.rootStore!.commentStore.sumTotal}
              loveit={loveit}
              isLike={isLike}
              currentPayWatermark={currentPayWatermark}
              currentIndexIsPayed={currentIndexIsPayed}
              currentPayGoodId={currentPayId}
              printCurrentImage={printCurrentImage}
            />
          )}
        </div>,
        wrapper
      )
    : null;
};

export default inject('rootStore')(observer(AllForBigPic));
